import React, { useState, useEffect, useCallback } from "react";

import { Redirect } from 'react-router';
import axios from "axios";
import { Form, Spin, Button, Modal, message } from "antd";
import { ExclamationCircleOutlined } from '@ant-design/icons';

import moment from "moment";
import useAuth from "../../hooks/useAuth";
import Mensajes from "../Mensajes/Mensajes";
import FormRegistroCasillas from "../MedidasSeguridad/FormRegistroCasillas"
import TablaRegistroCasillas from "../MedidasSeguridad/TablaRegistroCasillas"
import FormRegistroArticulo from "../MedidasSeguridad/FormRegistroArticulo"
import TablaRegistroArticulo from "../MedidasSeguridad/TablaRegistroArticulo"
import FormRegistroParticipantes from "../MedidasSeguridad/FormRegistroParticipantes"
import TablaRegistroParticipantes from "../MedidasSeguridad/TablaRegistroParticipantes"
import FormRegistroVerificacion from "../MedidasSeguridad/FormRegistroVerificacion"
let num = -1;
let verActiva = "";
let fechaVer = "";
let idMedidaVer = "";
let total = 0;
let nuevoGrupo = [];
export default function RegistraAdjudicacion(props) {
    //console.log("PROPS1", props)
    const urlConsultaMedidas = `${localStorage.getItem('SERVERCENTRAL')}/consultaMedidasSeguridad`;
    //const urlConsultaAdjudicaciones = `https://localhost:8443/docs_ws_adjudica/ws/consultaAdjudicaciones`;
    const urlGuardaMedidas = `${localStorage.getItem('SERVERCENTRAL')}/guardaMedidasSeguridad`;
    //const urlGuardaAdjudicaciones = `https://localhost:8443/docs_ws_adjudica/ws/guardaAdjudicaciones`;
    var tiempoMensaje = 5;
    const { user } = useAuth();
    const [optionsTA, setOptionsTA] = useState({
        data: [],
        loadingData: false
    });
    const [optionsTG, setOptionsTG] = useState({
        data: [],
        loadingData: false
    });

    const [optionsTGNuevo, setOptionsTGNuevo] = useState({
        data: [],
        loadingData: false
    });


    const [optionsTTA, setOptionsTTA] = useState({
        data: [],
        activa: -1
    });
    const [modifica, setModifica] = useState(-1);

    /*const [caracteristica, setCaracteristica] = useState({
        activa: ""
    });*/

    const [optionsCasillas, setOptionsCasillas] = useState({
        data: [],
        loadingData: false
    });

    /*const [casillasF, setCasillasF] =
        useState({
            key: "",
            tipoCasilla: "",
            cantidad: "",
            comentarios: "",
        });
    */
    const [optionsArticulos, setOptionsArticulos] = useState({
        data: [],
        loadingData: false
    });

    const [optionsParticipantes, setOptionsParticipantes] = useState({
        data: [],
        loadingData: false
    });
    const [optionsGrupos, setOptionsGrupos] = useState({
        data: [],
        loadingData: false
    });

    const [fecha, setFecha] = useState({
        fechaPE: ""
    });

    const [adjudicaciones, setAdjudicaciones] = useState({
        data: [],
        loadingData: false
    });

    const [casillas, setCasillas] = useState({
        data: [],
        loadingData: false
    });

    const [articulos, setArticulos] = useState({
        data: [],
        loadingData: false
    });

    const [participantes, setParticipantes] = useState({
        //data: response.data.entity.catalogos,
        data: [],
        loadingData: false,
    });

    const [acciones, setAcciones] = useState({
        enableCaptura: false,
        enableModificar: false
    });

    /*const [removeAdjudicaciones, setRemoveAdjudicaciones] = useState({
        data: []
    });*/

    const [removeCasillas, setRemoveCasillas] = useState({
        data: []
    });

    /*const [removeCasillasAux, setRemoveCasillasAux] = useState({
        data: []
    });*/

    const [removeArticulos, setRemoveArticulos] = useState({
        data: []
    });
    const [removeParticipantes, setRemoveParticipantes] = useState({
        data: []
    });
    const [participantesAux, setParticipantesAux] = useState({
        data: []
    });
    
    const [visibleAlert, setVisibleAlert] = useState({
        activado: false,
        tipoMensaje: "",
        mensaje: ""
    });

    const [redirect, setRedirect] = useState({
        redirecting: false,
        url: "/seguridad/verificaciones",
        idTipoDocumentacion: props.idTipoDocumentacion
    });

    /*const [rangeDates, setRangeDates] = useState({
        minInicio: moment().startOf('day'),
        minFin: moment().startOf('day')
    });
    const [enabledRangeDate, setEnabledRangeDate] = useState({
        fechaInicio: false,
        fechaFin: false,
    });*/
    const [verificacion, setVerificacion] = useState({
        numVerificacion: -1,
        activa: null,
        idMedida: ""
    });

   /* const [disableSwitch, setDisableSwitch] = useState(false);
    const [tipoCaptura, setTipoCaptura] = useState(1);


    const [fechaVerificacion, setFechaVerificacion] = useState({
        fechaPE: ""
    });

    const [numVerAux, setNumVerAux] = useState(3);*/

    //console.log("ESPERA", casillas.loadingData)
    function doRequestMedidas() {
        //console.log("Estoy en el consultar cambios", props.numVerificacion, "numero", num)
        //console.log("Estoy en el consultar cambios1", numVerAux)
        //  setVerificacion({
        //    numVerificacion: num && num !==null && num !== undefined && num !== ""? num:1
        //}) 
        let data = JSON.stringify({
            parametros: {
                idProceso: user.infoMenu.detalleSelec.idProcesoElectoral,
                idDetalleProceso: user.infoMenu.detalleSelec.idDetalleProceso,
                idEstado: user.infoMenu.estadoSelec !== null ? user.infoMenu.estadoSelec.idEstado : user.infoMenu.detalleSelec.idEstado,
                anioProceso: user.infoMenu.detalleSelec.anio,
                tipoProceso: user.infoMenu.detalleSelec.tipoProceso
            },
            idTipoDocumentacion: props.idTipoDocumentacion,
            idArticulo: props.idArticulo,
            opcion: props.opcion,
            numVerificacion:  props.opcion !==3?
                               num !==null && num !== undefined && num !== -1 ? num : -1 
                               : props.opcion ===3 ? 2:""

        })
        //console.log("Estoy en el consultar", data);
        axios
            .post(
                urlConsultaMedidas, data, {
                headers: {
                    'Authorization': localStorage.getItem('accessToken'),
                    'Content-Type': 'application/json',
                    Accept: "application/json",
                }
            }
            ).then(
                response => {
                    if (response.data.entity.code !== 200 && response.data.entity.code !== 403) {
                        /* setVisibleAlert(
                            {
                                activado: true,
                                tipoMensaje: "error",
                                mensaje: response.data.entity.causa
                            }); */
                        message.error("10.- Ocurrió un error. Comunícate al CAU", tiempoMensaje);
                    }
                    else if (response.data.entity.code === 200) {
                        ////console.log("Response g:=>", response);
                        if (response.data.entity.message !== null && response.data.entity.message !== "") {
                            /* setVisibleAlert(
                                {
                                    activado: true,
                                    tipoMensaje: "warning",
                                    mensaje: response.data.entity.message
                                }); */
                            message.warning(response.data.entity.message, tiempoMensaje);
                        }
                        else {
                            //console.log("Responsex:=>", response);

                            response.data.entity.fechaVerificacion!==null && response.data.entity.fechaVerificacion!==undefined?
                             fechaVer=response.data.entity.fechaVerificacion:fechaVer=moment().format('DD-MM-YYYY');
                             props.opcion!==3?
                             response.data.entity.numeroVerificacion !==null && response.data.entity.numeroVerificacion !==undefined?
                             num=response.data.entity.numeroVerificacion:num=num
                             :props.opcion===3 ?num=2:num=-1;

                             response.data.entity.verificacionActiva!==null && response.data.entity.verificacionActiva!==undefined?
                             verActiva=response.data.entity.verificacionActiva:verActiva=1; 
                             response.data.entity.idMedidaSeguridad!==null && response.data.entity.idMedidaSeguridad!==undefined?
                             idMedidaVer=response.data.entity.idMedidaSeguridad:idMedidaVer=null;
                            setFecha({
                                fechaPE: response.data.entity.fechaVerificacion,
                            })
                            //console.log("Response numero:=>", response.data.entity.numeroVerificacion, "otro", verificacion.numVerificacion);


                            setVerificacion({
                                numVerificacion: response.data.entity.numeroVerificacion,

                            })
                            ////console.log("Response numero2:=>", response.data.entity.numeroVerificacion, "otro", verificacion.numVerificacion);

                            response.data.entity.verificacionActiva !== null && response.data.entity.verificacionActiva !== undefined ?
                                setVerificacion({ activa: response.data.entity.verificacionActiva }) :
                                setVerificacion({ activa: 1 })
                            ////console.log("VERIFICACION ACTIVA", verificacion.activa)
                            setVerificacion({
                                idMedida: response.data.entity.idMedidaSeguridad
                            })

                            setOptionsTA({
                                //data: response.data.entity.catalogos,
                                data: response.data.entity.catalogosParticipantes,
                                loadingData: true,
                            });
                            setOptionsTG({
                                //data: response.data.entity.catalogos,
                                data: response.data.entity.catalogosGrupos,
                                loadingData: true,
                            });
                            total = optionsTG.data.length
                            setOptionsCasillas({
                                //data: response.data.entity.catalogos,
                                data: response.data.entity.catalogosCasillas,
                                loadingData: true,
                            });
                            //console.log("CATALOGOS",response.data.entity.catalogosArticulos)
                            setOptionsArticulos({
                                //data: response.data.entity.catalogos,
                                data: response.data.entity.catalogosArticulos,
                                loadingData: true,
                            });
                            //response.data.entity.catalogosParticipantes !==null &&  
                            //response.data.entity.catalogosParticipantes !== undefined &&
                            //response.data.entity.catalogosParticipantes !== "" &&
                            setOptionsParticipantes({
                                data: response.data.entity.catalogosParticipantes,
                                loadingData: true,
                            })
                            //response.data.entity.catalogosGrupos !==null &&  
                            //response.data.entity.catalogosGrupos !== undefined &&
                            //response.data.entity.catalogosGrupos !== "" &&
                            setOptionsGrupos({
                                data: response.data.entity.catalogosGrupos,
                                loadingData: true,
                            })
                            setCasillas({
                                data: response.data.entity.casillas,
                                loadingData: true
                            });
                            setArticulos({
                                data: response.data.entity.articulos,
                                loadingData: true
                            });
                            setParticipantes({
                                //data: response.data.entity.catalogos,
                                data: response.data.entity.participantes,
                                loadingData: true,
                            });
                            setAcciones({
                                enableCaptura: response.data.entity.enableCaptura,
                                enableModificar: response.data.entity.enableModificar
                            });
                        }
                    }
                    else {
                        localStorage.clear();
                        ////console.log("Borro el local storage");
                        window.location = "/login"
                    }
                }
            ).catch(err => {
                ////console.log("Error:=>: doRequestOptions", err)
                if (err.response.status === 403) {
                    localStorage.clear();
                    window.location = "/login"
                    return;
                }
                setOptionsTA({
                    data: [],
                    loadingData: true
                });
                setOptionsTGNuevo({
                    data: [],
                    loadingData: true
                });
                setOptionsTTA({
                    data: [],
                    loadingData: true
                });
                setOptionsTG({
                    data: [],
                    loadingData: true
                });
                setOptionsCasillas({
                    data: [],
                    loadingData: true
                });
                setOptionsArticulos({
                    data: [],
                    loadingData: true
                });
                setAdjudicaciones({
                    data: [],
                    loadingData: true
                });
                setCasillas({
                    data: [],
                    loadingData: true
                });
                setArticulos({
                    data: [],
                    loadingData: true
                });
                setParticipantes({
                    data: [],
                    loadingData: true
                });
                setVerificacion({
                    numVerificacion: -1,
                    activa: null
                })
                /* setVisibleAlert(
                    {
                        activado: true,
                        tipoMensaje: "error",
                        mensaje: "Ha ocurrido un error al realizar la petición solicitada"
                    }); */
                message.error("Ha ocurrido un error al realizar la petición solicitada.", tiempoMensaje);
            });
    };
    //console.log("RESPONSE otro", verificacion.numVerificacion);

    function doRequestGuarda() {
        //console.log("DATA REMOVE", removeCasillas.data);
        //console.log("Estoy en el guardar cambios", idMedidaVer, num, moment(fechaVer, dateFormat), verActiva)
      /*  if (removeCasillas.data.length > 0) {
            removeCasillas.data.map((value) => {
                if (value.idCasilla) {
                    removeCasillasAux.data.push(value)
                }

            })
        }*/
       /* if(removeArticulos.data.length > 0 && props.opcion===3){
            removeArticulos.data.map((art) => {
                participantes.data.map((part) => {
                    //console.log("part t", part.tipo,"art",art.nombre)
                if (part.tipo !==art.nombre) {
                    participantesAux.data.push(part)
                }
                
            })
            })
        }*/
        //console.log("aux part", participantesAux)
        let i = optionsTG.data.length;
        if (i > total) {
            optionsTG.data.map((value) => {
                let splited = value.split("-")
                //console.log("nuevo frupo", value, "s-", splited)
                if (splited[1] === 0 || splited[1] === '0') {
                    nuevoGrupo.push(value)
                }


            })
        }
        let data = JSON.stringify({
            parametros: {
                idProceso: user.infoMenu.detalleSelec.idProcesoElectoral,
                idDetalleProceso: user.infoMenu.detalleSelec.idDetalleProceso,
                idEstado: user.infoMenu.estadoSelec !== null ? user.infoMenu.estadoSelec.idEstado : user.infoMenu.detalleSelec.idEstado,
                anioProceso: user.infoMenu.detalleSelec.anio,
                tipoProceso: user.infoMenu.detalleSelec.tipoProceso
            },
            idTipoDocumentacion: props.idTipoDocumentacion,
            idArticulo: props.idArticulo,
            idMedidaSeguridad: idMedidaVer,
            numVerificacion: num,
            activa: verActiva,
            fecha: fechaVer,
            articulos: articulos.data,
            casillas: casillas.data,
            removeCasillas: removeCasillas.data,
            removeArticulos:removeArticulos.data,
            removeParticipantes:removeParticipantes.data,
            participantes: participantesAux.data.length>0?participantesAux.data:participantes.data,
            opcion: props.opcion,
            nuevoGrupo: nuevoGrupo
        })
        //console.log("inf a casillas", casillas.data[i - 1])
        //console.log("inf a guardar", data)
        axios
            .post(
                urlGuardaMedidas, data, {
                headers: {
                    'Authorization': localStorage.getItem('accessToken'),
                    'Content-Type': 'application/json',
                    Accept: "application/json",
                }
            }
            ).then(
                response => {
                    if (response.data.entity.code !== 200 && response.data.entity.code !== 403) {
                        /* setVisibleAlert(
                            {
                                activado: true,
                                tipoMensaje: "error",
                                mensaje: response.data.entity.causa
                            }); */
                        message.error("10.- Ocurrió un error. Comunícate al CAU", tiempoMensaje);
                    }
                    else if (response.data.entity.code === 200) {
                        if (response.data.entity.message !== null && response.data.entity.message !== "") {
                            /* setVisibleAlert(
                                {
                                    activado: true,
                                    tipoMensaje: "warning",
                                    mensaje: response.data.entity.message
                                }); */
                            message.warning(response.data.entity.message, tiempoMensaje);
                        }
                        else {
                            message.success("Se guardó correctamente la verificación de las medidas de seguridad", tiempoMensaje);
                            /*  setRedirect({
                                redirecting: true,
                                url: "/seguridad/verificaciones",
                               
                            });*/
                            // Cambio del reload al guardar RMA
                            //window.location ="/seguridad/verificaciones"
                            setCasillas({
                                data: [],
                                loadingData: false
                            });
                            setArticulos({
                                data: [],
                                loadingData: false
                            });
                            setOptionsTTA({
                                data: [],
                                loadingData: false
                            });
                            setParticipantes({
                                data: [],
                                loadingData: false
                            });
                             setParticipantesAux({
                                data: [],
                                loadingData: false
                            });
                            setRemoveArticulos({
                                data: [],
                                loadingData: false
                            });
                            setRemoveCasillas({ 
                                data: [],
                                loadingData: false
                            });
                            setRemoveParticipantes({ 
                                data: [],
                                loadingData: false
                            });
                        }
                    }
                    else {
                        localStorage.clear();
                        // //console.log("Borro el local storage");
                        window.location = "/login"
                    }
                }
            ).catch(err => {
                ////console.log("Error:=>: doRequestOptions", err)
                if (err.response.status === 403) {
                    localStorage.clear();
                    window.location = "/login"
                    return;
                }
                
                message.error("Ha ocurrido un error al realizar la petición solicitada", tiempoMensaje);
                setParticipantesAux({
                    data:[],
                })
            });
    };

    function showConfirmGuardar() {
        ////console.log("DATA 1",  adjudicaciones.data);
        var hoy =moment().startOf('day')
        var fecha = moment(fechaVer, "DD-MM-YYYY").toDate();
        let  diferencia=hoy -fecha;
        diferencia=diferencia/(1000 * 3600 * 24);
        //console.log("HOY", hoy,"fecha",fecha,"DIFF",diferencia, "activa", verActiva)
        if(diferencia>7 && verActiva===1){
            Modal.confirm({
                title: 'Han pasado más de 7 días desde la fecha de verificación, si la información es correcta, ¿desea continuar con el guardado de la verificación?',
                icon: <ExclamationCircleOutlined />,
                //content: 'Some descriptions',
                okText: 'Aceptar',
                cancelText: 'Cancelar',
                onOk() {
                    //console.log('Aceptar');
                    doRequestGuarda();
                },
                onCancel() {
                    ////console.log('Cancelar');
                },
            });

        }
        else{
        Modal.confirm({
            title: '¿Está seguro de guardar la verificación?',
            icon: <ExclamationCircleOutlined />,
            //content: 'Some descriptions',
            okText: 'Aceptar',
            cancelText: 'Cancelar',
            onOk() {
                //console.log('Aceptar');
                doRequestGuarda();
            },
            onCancel() {
                ////console.log('Cancelar');
            },
        });
    }
    }

    function showConfirmCancelar() {
        Modal.confirm({
            title: '¿Está seguro cancelar el guardado de la información.?',
            icon: <ExclamationCircleOutlined />,
            //content: 'Some descriptions',
            okText: 'Aceptar',
            cancelText: 'Cancelar',
            onOk() {
                ////console.log('Aceptar');
                // setRedirect({
                //    redirecting: true,
                //    url: "/seguridad/verificaciones",
                //    idTipoDocumentacion: props.idTipoDocumentacion
                //});
                window.location.reload(); 
            },
            onCancel() {
                ////console.log('Cancelar');
            },
        });
    }

    const dateFormat = "DD-MM-YYYY";
    const timeFormat = "HH:mm";


    function validaFormulario(value) {
        //console.log("VALIDA FORM", value)
        value.verificacionActiva === false ?
            verActiva = 0 : verActiva = 1;

         fechaVer = moment.isMoment(value.fechaVerificacion) 
               ? value.fechaVerificacion.format('DD-MM-YYYY')  // Convertir moment a string
               : value.fechaVerificacion; // Si ya es string, lo dejamos igual 
        setFecha({
            fechaPE: fechaVer,
        })


    }

    function handleCambio(value) {
        //console.log("estoy value Cambio:=>****", value)
        num = value
        //setNumVerAux(num);
        doRequestMedidas()
 }


    function handleGuardaCasillas(value) {
        //console.log("values casillas", value)
        setVisibleAlert(
            {
                activado: false,
                tipoMensaje: "",
                mensaje: ""
            });

        // //console.log("FECHA,",moment(value.fechaVerificacion).format('DD-MM-YYYY'))
       

        setVerificacion({
            activa: value.verificacionActiva,
        })
        if (value.idMedida !== null && value.idMedida !== undefined && value.idMedida !== "") {
            setVerificacion({
                idMedida: value.idMedida
            })
        }
     value.key = -(new Date()).getTime();
       
        setCasillas({
            data: [...casillas.data, value],
            loadingData: true
        });
     
    }

    function handleSaveDataCasillas(item, index, newData) {
        //console.log("handleSaveData:=>newData1artpart ", newData);
        setVisibleAlert(
            {
                activado: false,
                tipoMensaje: "",
                mensaje: ""
            });
        newData.key = -(new Date()).getTime();
       
        
        const newCasillasData = [...casillas.data];
        newCasillasData.splice(index, 1, {
            ...item,
            ...newData
        });
        setCasillas({
            data: [...newCasillasData],
            loadingData: true
        });
       
        
    }


    function handleGuardaArticulos(value) {
        //console.log("value Articulosxxx:=>****", value);
        setVisibleAlert(
            {
                activado: false,
                tipoMensaje: "",
                mensaje: ""
            });
            setModifica(-1);

        //console.log("CARACTERISTICA 1x", value.caracteristica)
        if (value.caracteristica === 1 || value.caracteristica === '1' || value.caracteristica ==="1") {
            //console.log("CARACTERISTICA 2", optionsTTA.data)
            if( optionsTTA.data.length !== 2){
                //console.log("MODIFICAR NEW1", value.nombre, optionsTTA.data[0])
                if(optionsTTA.data[0] !== value.nombre){
                setOptionsTTA({
                    data:[...optionsTTA.data, value.nombre],
                    activa:1
                })
            }
            else 
            {
                setOptionsTTA({
                    data:optionsTTA.data,
                    activa:1
                })
            }
            }

        }
        else
            setOptionsTTA({
                 data: optionsTTA.data,
                activa: 2,
            });

       
       value.key = -(new Date()).getTime();
    
        setArticulos({
            data: [...articulos.data, value],
            loadingData: true
        });
       
    }
    //console.log("CARACTERISTICA 1a", optionsTTA)

    function handleSaveData(item, index, newData) {
        //console.log("handleSaveData:=>newData1p ", newData);
        setVisibleAlert(
            {
                activado: false,
                tipoMensaje: "",
                mensaje: ""
            });
        newData.key = -(new Date()).getTime();
        
        const newArticulosData = [...articulos.data];
        newArticulosData.splice(index, 1, {
            ...item,
            ...newData
        });
        setArticulos({
            data: [...newArticulosData],
            loadingData: true
        });
        
    }
    function handleModificarData( newData) {
        //console.log("MODIFICAR NEW", newData, optionsTTA)
        if(optionsTTA.activa!==1){
           if( optionsTTA.data.length !== 2){
            //console.log("MODIFICAR NEW1", newData.nombre, optionsTTA.data[0])
            if(optionsTTA.data[0] !== newData.nombre){
            setOptionsTTA({
                data:[...optionsTTA.data, newData.nombre],
                activa:1
            })
        }
        else 
        {
            setOptionsTTA({
                data:optionsTTA.data,
                activa:1
            })
        }
        
        }
        else
        {
            setOptionsTTA({
                data:optionsTTA.data,
                activa:1
            }) 
        }
        }
        else
        {
            if( optionsTTA.data.length !== 2){
                //console.log("MODIFICAR NEW1", newData.nombre, optionsTTA.data[0])
                if(optionsTTA.data[0] !== newData.nombre){
                setOptionsTTA({
                    data:[...optionsTTA.data, newData.nombre],
                    activa:1
                })
            }
            else 
            {
                setOptionsTTA({
                    data:optionsTTA.data,
                    activa:1
                })
            }
            
            }
            else
            {
                setOptionsTTA({
                    data:optionsTTA.data,
                    activa:1
                }) 
            }

        }

    }
    function handleGuardaParticipantes(value) {
        console.log("value Participantes1:=>****", value, participantes.data);
        let agregar=true;
        setVisibleAlert(
            {
                activado: false,
                tipoMensaje: "",
                mensaje: ""
            });

      value.key = -(new Date()).getTime();
     participantes.data.map((val) => {
        if (val.nombre===value.nombre && val.grupo===value.grupo && val.tipo===value.tipo) {
            val.cantidad=value.cantidad+val.cantidad
            agregar=false
        }

    })
    if(agregar)
        setParticipantes({
            data: [...participantes.data, value],
            loadingData: true
        });
        //}
    }

    function handleSaveParticipantes(item, index, newData) {
        //console.log("handleSaveData:=>newData1 ", newData);
        setVisibleAlert(
            {
                activado: false,
                tipoMensaje: "",
                mensaje: ""
            });
        newData.key = -(new Date()).getTime();
        
        const newParticipantesData = [...participantes.data];
        newParticipantesData.splice(index, 1, {
            ...item,
            ...newData
        });
        setParticipantes({
            data: [...newParticipantesData],
            loadingData: true
        });
  
        
    }


    function handleRemoveData(newData, deleteRow) {
        ////console.log("handleRemoveData:=>newData ", newData);
        ////console.log("handleRemoveData:=>deleteRow ", deleteRow);
        setVisibleAlert(
            {
                activado: false,
                tipoMensaje: "",
                mensaje: ""
            });
        setCasillas({
            data: newData,
            loadingData: true
        });

        
        //console.log("REmove", deleteRow[0])
        if (deleteRow[0].idCasilla) {
            setRemoveCasillas({
                data: [...removeCasillas.data, deleteRow[0]]
            });
        }
    }

    function handleRemoveArt(newData, deleteRow) {
        // //console.log("handleRemoveData:=>newData ", newData);
        // //console.log("handleRemoveData:=>deleteRow ", deleteRow);
        setVisibleAlert(
            {
                activado: false,
                tipoMensaje: "",
                mensaje: ""
            });
        setArticulos({
            data: newData,
            loadingData: true
        });
        console.log("borrado art",deleteRow[0], "part", participantes.data)
        let filtro ="";
        filtro = participantes.data.filter(item => item.tipo != deleteRow[0].nombre)
        console.log("borrado art",deleteRow[0].nombre, "part", participantes.data, "filtro1", filtro)
        participantes.data=filtro
        if (deleteRow[0].id) {
            setRemoveArticulos({
                data: [...removeArticulos.data, deleteRow[0]]
            });
        }
    }

    function handleRemoveParti(newData, deleteRow) {
        ////console.log("handleRemoveData:=>newData ", newData);
        ////console.log("handleRemoveData:=>deleteRow ", deleteRow);
        setVisibleAlert(
            {
                activado: false,
                tipoMensaje: "",
                mensaje: ""
            });
        setParticipantes({
            data: newData,
            loadingData: true
        });
        if (deleteRow[0].idParticipante) {
            setRemoveParticipantes({
                data: [...removeParticipantes.data, deleteRow[0]]
            });
        }
    }

    const handleClose = () => {
        setVisibleAlert({
            activado: false,
            tipoMensaje: "",
            mensaje: ""
        });
    }

    const handleClickGuardar = useCallback(() => {
        setAcciones({
            enableCaptura: acciones.enableCaptura,
            enableModificar: false
        });
        //console.log("DATA guardar", WrappedFormRegistroVerificacion.props);
        showConfirmGuardar();
    });

    const handleClickCancelar = useCallback(() => {
        showConfirmCancelar();
    });

    useEffect(() => {
        //console.log("entre usse efecct", adjudicaciones.loadingData)
        // Cambio del reload al guardar RMA Se agrego articulos
        if (!casillas.loadingData && !articulos.loadingData)
            doRequestMedidas();
        // Cambio del reload al guardar RMA
    }, [/*adjudicaciones,*/ casillas, articulos /*, verificacion*/]);

    const renderRedirectRegresar = () => {
        if (redirect.redirecting) {
            return <Redirect
                to={{
                    pathname: redirect.url,
                    state: {
                        idTipoDocumentacion: redirect.idTipoDocumentacion
                    }
                }}
            />
        }
    }


    const WrappedFormRegistroCasillas = Form.create({ name: 'casillas' })(FormRegistroCasillas);
    const WrappedFormRegistroArticulo = Form.create({ name: 'articulo' })(FormRegistroArticulo);
    const WrappedFormRegistroParticipantes = Form.create({ name: 'participante' })(FormRegistroParticipantes);
    const WrappedFormRegistroVerificacion = Form.create({ name: 'verificacion' })(FormRegistroVerificacion);
    ////console.log("acciones", acciones);
    return (
        <div className="div_consultaadj">
            {renderRedirectRegresar()}
            {visibleAlert.activado ?
                (
                    <Mensajes tipoMensaje={visibleAlert.tipoMensaje} mensaje={visibleAlert.mensaje} handleClose={handleClose} />
                ) : null}
            <br />
            {!casillas.loadingData /*// Cambio del reload al guardar RMA !adjudicaciones.loadingData && !optionsCasillas.loadingData*/ ? (<Spin size="large" />) : (

                <div>

                    {//console.log("Response numero1:=>", num)
                    }

                    <WrappedFormRegistroVerificacion
                          enableCaptura={acciones.enableCaptura}
                          fecha={fecha.fechaPE}
                          numVerificacion={num ==="" && props.opcion !==3 ? 1
                          :num !==""  && props.opcion !==3 ? num: props.opcion === 3 && 2}
                          handleCambio={handleCambio}
                          validaFormulario={validaFormulario}
                          opcion={props.opcion}
                          idMedida={verificacion.idMedida}
                          activa={props.opcion!==3  ? 
                              verActiva ===1 ?true
                              :verActiva !==1 && false
                              :props.opcion ===3 && true}
                    />


                    <WrappedFormRegistroCasillas
                        optionsTipo={optionsCasillas.data}
                        data={casillas.data}
                        nombreArticulo={props.nombreArticulo}
                        enableCaptura={acciones.enableCaptura}
                        fecha={fecha.fechaPE}
                        numVerificacion={num === "" && props.opcion !== 3 ? 1 : num === "" && props.opcion === 3 ? 2
                            : num !== "" && num}
                        handleSubmit={handleGuardaCasillas}
                        handleCambio={handleCambio}
                        opcion={props.opcion}
                        idMedida={verificacion.idMedida}
                        activa={verificacion.activa === 0 && props.opcion !== 3 ? false : true}
                    />
                    <TablaRegistroCasillas
                        optionsTipo={optionsCasillas.data}
                        data={casillas.data}
                        enableEdit={true}
                        enableDelete={true}
                        enableCaptura={acciones.enableCaptura}
                        enableModificar={acciones.enableModificar}
                        handleSaveData={handleSaveDataCasillas.bind(this)}
                        handleRemoveData={handleRemoveData.bind(this)}
                        idArticulo={props.idArticulo}
                        idTipoDocumentacion={props.idTipoDocumentacion}
                        nombreArticulo={props.nombreArticulo}
                        opcion={props.opcion}
                    />
                    <br />
                    <WrappedFormRegistroArticulo
                        optionsTipoA={optionsArticulos.data}
                        data={articulos.data}
                        nombreArticulo={props.nombreArticulo}
                        enableCaptura={acciones.enableCaptura}
                        fecha={fecha.fechaPE}
                        handleSubmit={handleGuardaArticulos}
                        opcion={props.opcion} />
                    <TablaRegistroArticulo
                        optionsTipoA={optionsArticulos.data}
                        data={articulos.data}
                        enableEdit={true}
                        enableDelete={true}
                        enableCaptura={acciones.enableCaptura}
                        enableModificar={acciones.enableModificar}
                        handleSaveData={handleSaveData.bind(this)}
                        handleModificarData={handleModificarData.bind(this)}
                        handleRemoveArt={handleRemoveArt.bind(this)}
                        idArticulo={props.idArticulo}
                        idTipoDocumentacion={props.idTipoDocumentacion}
                        nombreArticulo={props.nombreArticulo}
                        opcion={props.opcion}

                    />
                    <br />{//console.log("PARTICIPANTES INICIO,participantes.data", optionsTTA.activa, "m", optionsTTA.modifica, "op", props.opcion )
                    }
                    {props.opcion === 3 && optionsTTA.activa === 1 &&                   <>
                            <WrappedFormRegistroParticipantes
                                optionsTipoParticipante={optionsTA.data}
                                optionsTipoGrupo={optionsTG.data}
                                optionsTipoArticulo={optionsTTA.data}
                                nombreArticulo={props.nombreArticulo}
                                enableCaptura={acciones.enableCaptura}
                                fecha={fecha.fechaPE}
                                handleSubmit={handleGuardaParticipantes}
                                opcion={props.opcion}
                            />

                            <TablaRegistroParticipantes
                                optionsTipoParticipante={optionsTA.data}
                                optionsTipoGrupo={optionsTG.data}
                                optionsTipoArticulo={optionsTTA.data}
                                data={participantes.data}
                                enableEdit={true}
                                enableDelete={true}
                                enableCaptura={acciones.enableCaptura}
                                enableModificar={acciones.enableModificar}
                                handleSaveData={handleSaveParticipantes.bind(this)}
                                handleRemoveParti={ handleRemoveParti.bind(this)}
                                idArticulo={props.idArticulo}
                                idTipoDocumentacion={props.idTipoDocumentacion}
                                nombreArticulo={props.nombreArticulo}
                                opcion={props.opcion}
                            />
                        </> }
                      


                    <div className="div_botones">
                        <Button
                            className="cancelar"
                            onClick={handleClickCancelar.bind(this)}
                        > Cancelar </Button>
                        <Button
                            style={{ marginLeft: '10px' }}
                            className="guardar"
                            onClick={handleClickGuardar.bind(this)}
                            disabled={casillas.data.length === 0 || articulos.data.length === 0 || !acciones.enableModificar || (props.opcion === 3 && optionsTTA.activa === 1 && participantes.data.length === 0)}
                        > Guardar Cambios</Button>
                    </div>
                </div>
            )}
        </div>
    )

}